import {isFalsy} from '@/helpers/index';

export class Filter<T extends {[key: string]: string}> {
  private readonly defaultValues: this;

  constructor(values: T) {
    Object.assign(this, values);

    this.defaultValues = structuredClone(this);
    Object.defineProperty(this, 'defaultValues', {
      enumerable: false,
    });
  }

  loadFromQuery(query: Record<string, any>) {
    for (const key in this) {
      this[key] = query[key];
    }
  }

  buildSearchParams(searchParams: URLSearchParams) {
    for (const key in this) {
      if (!isFalsy(this[key])) {
        searchParams.append(key, String(this[key]));
      }
    }
    return searchParams;
  }

  reset(values: Partial<this> = {}) {
    const defaultValues = structuredClone(this.defaultValues);
    for (const key in this) {
      this[key] = values[key] ? values[key] : defaultValues[key];
    }
  }
}
